var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"items":_vm.items,"small-chips":"","label":_vm.labelText,"multiple":"","item-text":"text","item-value":"value","outlined":"","dense":"","clearable":true,"hide-details":""},on:{"input":event => { _vm.$emit('input', event) }},model:{value:(_vm.chips),callback:function ($$v) {_vm.chips=$$v},expression:"chips"}})
}
var staticRenderFns = []

export { render, staticRenderFns }